import React from 'react'
import MaterialSymbol from '../material-symbol'

const Event = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="event" {...props} />
))

Event.displayName = 'Event'

export default Event
